var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximiseNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/maximize-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/maximize-3_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.24935 14.8307H10.7493C13.666 14.8307 14.8327 13.6641 14.8327 10.7474V7.2474C14.8327 4.33073 13.666 3.16406 10.7493 3.16406H7.24935C4.33268 3.16406 3.16602 4.33073 3.16602 7.2474V10.7474C3.16602 13.6641 4.33268 14.8307 7.24935 14.8307Z",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 5.5L5.5 12.5",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4993 7.83333V5.5H10.166",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.5 10.1641V12.4974H7.83333",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximiseNoteIcon);
export default __webpack_public_path__ + "static/media/maximise-note-icon.ae399011f402cc9bf388cd4f5f7384e3.svg";
export { ForwardRef as ReactComponent };